import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { UserService } from '../../services/user.service';

@Component({
  selector: 'nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {
  @Input() currentApp: string;
  @Input() apps: any;
  @Input() loadedApps: string[];
  @Output() runApp: EventEmitter<string> = new EventEmitter();
  @Output() switch: EventEmitter<string> = new EventEmitter();
  @Output() close: EventEmitter<string> = new EventEmitter();
  appKeys: string[];
  userName: string;

  constructor(private UserService: UserService, private router: Router) { }

  ngOnInit() {
    this.appKeys = Object.keys(this.apps || {});
    this.userName = JSON.parse(localStorage['lscache-currentUser'] || '{}').name;
  }

  logOut() {
    this.UserService
      .logOut()
      .subscribe(
      res => { this.router.navigate(['/']) },
      err => { }
      );
  }

  loadApp(appName: string) {
    this.runApp.emit(appName);
  }

  switchApp(appName: string) {
    this.switch.emit(appName);
  }

  closeApp(appName: string) {
    this.close.emit(appName);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/nav-bar/nav-bar.component.ts